"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var PrepDetailsChangesEdit_1 = require("../../../gen-src/icons/PrepDetailsChangesEdit");
var Localize_1 = require("../../../gen-src/Localize");
var maxDescriptionCharacterLength = 4000;
var ColumnInlineDescriptionEditor = /** @class */ (function (_super) {
    __extends(ColumnInlineDescriptionEditor, _super);
    function ColumnInlineDescriptionEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.localIsMounted = false;
        _this.enterEditDescriptionMode = function () {
            if (_this.localIsMounted) {
                _this.setState({ isInEditDescriptionMode: true });
            }
        };
        _this.handleBodyChange = function (event) {
            if (_this.localIsMounted) {
                _this.setState({ inputText: event.target.value });
            }
        };
        _this.handleSaveDescription = function () {
            if (_this.localIsMounted) {
                _this.setState({ isWaitingForSetDescriptionCallback: true });
                _this.setDescription().catch(function () {
                    if (_this.localIsMounted) {
                        _this.setState({ isWaitingForSetDescriptionCallback: false, isInEditDescriptionMode: false });
                    }
                });
            }
        };
        _this.handleCancelEditDescription = function () {
            if (_this.localIsMounted) {
                _this.setState({ inputText: _this.props.description, isInEditDescriptionMode: false });
            }
        };
        _this.state = {
            userHasEditDescriptionPermissions: false,
            isInEditDescriptionMode: false,
            isWaitingForSetDescriptionCallback: false,
            inputText: _this.props.description,
            currentDescription: props.description
        };
        return _this;
    }
    ColumnInlineDescriptionEditor.prototype.requestEditDescriptionPermissions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var args, value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props.tableVizportalId) return [3 /*break*/, 2];
                        args = {
                            tableVizportalId: this.props.tableVizportalId
                        };
                        return [4 /*yield*/, this.props.apiRequests.canUserSetColumnDescription(args)];
                    case 1:
                        value = _a.sent();
                        if (value && this.localIsMounted) {
                            this.setState({ userHasEditDescriptionPermissions: value });
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ColumnInlineDescriptionEditor.prototype.setDescription = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var args;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        args = {
                            columnVizportalId: (_a = this.props.columnVizportalId, (_a !== null && _a !== void 0 ? _a : '')),
                            description: this.state.inputText
                        };
                        return [4 /*yield*/, this.props.apiRequests.setColumnDescription(args)
                                .then(function () {
                                if (_this.localIsMounted) {
                                    _this.setState({
                                        isWaitingForSetDescriptionCallback: false,
                                        isInEditDescriptionMode: false,
                                        currentDescription: args.description
                                    });
                                }
                                window.setTimeout(_this.props.onUpdate, 2000);
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ColumnInlineDescriptionEditor.prototype.renderEditDescriptionButton = function () {
        return (React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Icon, handleClick: this.enterEditDescriptionMode, title: Localize_1.Messages.EditDescription(), testId: 'edit-description', getContent: function () { return React.createElement(PrepDetailsChangesEdit_1.SvgPrepDetailsChangesEdit, null); } }));
    };
    ColumnInlineDescriptionEditor.prototype.renderSaveAndCancelButtons = function () {
        return (React.createElement(data_catalog_shared_1.SaveAndCancelButtonsWrapper, null,
            React.createElement(data_catalog_shared_1.SaveAndCancelButtonsFlexWrapper, null,
                React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Primary, handleClick: this.handleSaveDescription, title: Localize_1.Messages.Save(), testId: 'save-description', style: { marginBottom: widgets_1.TabStyles.Spacing.DefaultSpace }, disabled: this.state.isWaitingForSetDescriptionCallback }, Localize_1.Messages.Save()),
                React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, handleClick: this.handleCancelEditDescription, title: Localize_1.Messages.Cancel(), testId: 'cancel-description', disabled: this.state.isWaitingForSetDescriptionCallback }, Localize_1.Messages.Cancel()))));
    };
    ColumnInlineDescriptionEditor.prototype.renderTextArea = function () {
        return (React.createElement(data_catalog_shared_1.ColumnTableCell, null,
            React.createElement(data_catalog_shared_1.ColumnDetailsTextAreaWrapper, null,
                React.createElement("textarea", { value: this.state.inputText, className: 'inline-description-editor-text-area', onChange: this.handleBodyChange, style: data_catalog_shared_1.columnDetailsTextAreaStyle, disabled: this.state.isWaitingForSetDescriptionCallback, maxLength: maxDescriptionCharacterLength }),
                this.renderSaveAndCancelButtons())));
    };
    ColumnInlineDescriptionEditor.prototype.render = function () {
        return (React.createElement(data_catalog_shared_1.ColumnDetailsProperty, null,
            React.createElement(data_catalog_shared_1.ColumnDetailsLabel, null, Localize_1.Messages.Description()),
            this.state.isInEditDescriptionMode ?
                this.renderTextArea() :
                React.createElement(data_catalog_shared_1.ColumnDetailsDescriptionValue, null,
                    React.createElement("div", { style: { maxHeight: data_catalog_shared_1.descriptionMaxHeight } }, this.state.currentDescription ? this.state.currentDescription :
                        React.createElement(data_catalog_shared_1.ColumnDetailsPlaceholder, null, Localize_1.Messages.NoDescriptionAvailable()))),
            this.state.userHasEditDescriptionPermissions && !this.state.isInEditDescriptionMode ? this.renderEditDescriptionButton() : null));
    };
    ColumnInlineDescriptionEditor.prototype.componentDidMount = function () {
        this.localIsMounted = true;
        this.requestEditDescriptionPermissions().catch(function (err) { console.warn(err); });
    };
    ColumnInlineDescriptionEditor.prototype.componentWillUnmount = function () {
        this.localIsMounted = false;
    };
    return ColumnInlineDescriptionEditor;
}(React.Component));
exports.ColumnInlineDescriptionEditor = ColumnInlineDescriptionEditor;
//# sourceMappingURL=ColumnInlineDescriptionEditor.js.map